<template>
  <div v-if="QnA">
    <h4 class="qna-title">已設定的問題和答案</h4>
    <div v-for="(answer, index) in filterQnA" :key="`question-${index}`" class="row-style">
      <div>問題及答案{{ index + 1 }}</div>
      <div class="qna">
        <div>{{ answer.question }}</div>
        <div class="answer">
          <div v-if="answer.answer" v-html="answer.answer"></div>
          <di v-else>會員未有回答已設定問題</di>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    QnA: {
      type: Array,
      default: null,
    },
  },
  computed: {
    filterQnA() {
      // Coupon has questions set + User answers ALL questions
      // - Display 已設定問題和答案 + display all questions with user answers

      // Coupon has questions set + User answers only SOME questions
      // - Display 已設定問題和答案 + display questions with answers only

      // Coupon has questions set + User did not answer any question
      // - Display 已設定問題和答案 + display 會員未有回答已設定問題。

      // Coupon has NO question set
      // - Hide 已設定問題和答案 title
      if (this.QnA) {
        const a = this.QnA.filter((arr) => arr.answer.toString().length > 0);
        if (a.length > 0) {
          return a;
        }
        return this.QnA;
      }
      return [];
    },
  },
};
</script>
<style lang="scss" scoped>
.row-style {
  width: 100%;
  border-bottom: 1px solid #ebeef0 !important;
  display: flex;
  gap: 3rem;
  padding: 8px 0;

  div {
    overflow: unset !important;
    white-space: normal !important;
  }
}

.qna-title {
  font-size: 18px;
}

@include respond(phone) {
  .qna-title {
    font-size: 14px;
    margin-top: 10px;
  }
}

.qna {
  flex: 1;
}

.answer {
  color: DodgerBlue;
}
</style>
